/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Skip_TitleInputs */

const en_spellcheck_skip_title = /** @type {(inputs: Spellcheck_Skip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip/Ignore`)
};

const fr_spellcheck_skip_title = /** @type {(inputs: Spellcheck_Skip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorer`)
};

const de_spellcheck_skip_title = /** @type {(inputs: Spellcheck_Skip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überspringen/Ignorieren`)
};

const it_spellcheck_skip_title = /** @type {(inputs: Spellcheck_Skip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salta/Ignora`)
};

const ru_spellcheck_skip_title = /** @type {(inputs: Spellcheck_Skip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пропустить/Игнорировать`)
};

const es_spellcheck_skip_title = /** @type {(inputs: Spellcheck_Skip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saltar/Ignorar`)
};

const zh_cn2_spellcheck_skip_title = /** @type {(inputs: Spellcheck_Skip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跳过/忽略`)
};

const ja_spellcheck_skip_title = /** @type {(inputs: Spellcheck_Skip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スキップ/無視`)
};

const hi_spellcheck_skip_title = /** @type {(inputs: Spellcheck_Skip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छोड़ें/अनदेखा करें`)
};

const pt_pt2_spellcheck_skip_title = /** @type {(inputs: Spellcheck_Skip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar/Pular`)
};

/**
* | output |
* | --- |
* | "Skip/Ignore" |
*
* @param {Spellcheck_Skip_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_skip_title = /** @type {((inputs?: Spellcheck_Skip_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Skip_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_skip_title(inputs)
	if (locale === "de") return de_spellcheck_skip_title(inputs)
	if (locale === "it") return it_spellcheck_skip_title(inputs)
	if (locale === "ru") return ru_spellcheck_skip_title(inputs)
	if (locale === "es") return es_spellcheck_skip_title(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_skip_title(inputs)
	if (locale === "ja") return ja_spellcheck_skip_title(inputs)
	if (locale === "hi") return hi_spellcheck_skip_title(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_skip_title(inputs)
	return en_spellcheck_skip_title(inputs)
});